import { ApiError } from "@vana/core";

export class ListReschedulesError extends ApiError {}

export class ListAmbassadorsError extends ApiError {}

export class ReprogramError extends ApiError {}

export class EscalateError extends ApiError {}

export class GetMaxAttemptsError extends ApiError {}
